'use client';

const AiIdentification = ({ text }: { text?: string }) => {
  return (
    <div className="text-muted-foreground text-xs w-fit flex items-center">
      {text || '内容由 AI 生成，仅供参考，请仔细甄别'}
    </div>
  );
};

export default AiIdentification;
